import React from "react";
import { connect } from "react-redux";
import SubProfile from "./components/SubProfile";

class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fileList: []
    };
  }

  getFileList = file => {
    const { fileList } = this.state;
    this.setState({
      fileList: fileList && fileList.length && file && file.length ? fileList.concat(file) : file
    });
  };

  render() {
    const { fileList } = this.state;
    const { location } = this.props
    return (
      <div>
        <SubProfile
          getFileList={this.getFileList}
          fileList={fileList}
          path={(location && location.pathname) || ""}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    userDetails: state && state.loginUser
  };
};

export default connect(mapStateToProps)(Profile);
